/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useState, useCallback, useRef, useEffect} from 'react'
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../../redux/helper/CreateQuery';

const OutstandingInvoiceReportFilterModal = ({filterModal,setFilterModal, selected, setselected, Filter, setFilter, handleFilter, setfilterValue, filterValue, handleOutstandingInvoiceReport, outstandingInvoiceList, setOutstandingInvoiceList, SetSuccessMessage,}) => {
    const dateRef = useRef();
    const dateRef1 = useRef();
    const [selectedType, setselectedType] = useState('invoice_date');

    const toggleState = {
        invoice_start_date: false,
        invoice_end_date: false,
        ar_start_date: false,
        ar_end_date: false,
    };

    const [toggle, settoggle] = useState(toggleState);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'class':
                if (Filter[key].length > 0) {
                    final += `&class=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (selected.invoice_start_date !== '' && selected.invoice_end_date !== '') {
            final += `&TRX_DATE=${moment(selected.invoice_start_date).format('DD-MM-YYYY')},${moment(selected.invoice_end_date).format('DD-MM-YYYY')}`;
        }
        if (selected.ar_start_date !== '' && selected.ar_end_date !== '') {
            final += `&AR_DATE=${moment(selected.ar_start_date).format('DD-MM-YYYY')},${moment(selected.ar_end_date).format('DD-MM-YYYY')}`;
        }

        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filters applied Successfully!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);
        return final;
    };

    const handleDateIN = (val, key) => {
        const state = key === 'invoice_start_date' ? 'invoice_end_date' : 'invoice_start_date';
        if (key === 'invoice_start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'invoice_end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'invoice_end_date') {
            settoggle(toggleState);
        }
    };

    const handleDateAR = (val, key) => {
        const state = key === 'ar_start_date' ? 'ar_end_date' : 'ar_start_date';
        if (key === 'ar_start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'ar_end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'ar_end_date') {
            settoggle(toggleState);
        }
    };

    const handleClear = () => {
        setFilter({
            class:[],
        });
        setselected({ invoice_start_date: '', invoice_end_date: '', ar_start_date: '', ar_end_date: '', });
        setfilterValue('');
        handleOutstandingInvoiceReport();
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared!');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 1000);
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    invoice_start_date: false,
                    invoice_end_date: false,            
                }));
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    useEffect(() => {
        const handler = (event) => {
            if (dateRef1 && !dateRef1.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    ar_start_date: false,
                    ar_end_date: false,                
                }));
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef1]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[575px] mx-auto px-2.5" style={{margin : 'auto'}}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[14px] rounded-t-md">
                        <h5 className="sm:text-xs4 text-lg font-semibold text-[#555259] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button 
                            type="button" 
                            className="absolute top-4 right-6" 
                            data-bs-dismiss="modal" 
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" className="w-3.5 h-3.5"/>
                        </button>
                    </div>
                    <div className="modal-body relative sm:pl-5 pr-7 px-3 sm:pt-5 pt-4 pb-[18px] text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start mb-4" role="presentation" onClick={() => setselectedType('invoice_date')}>
                                    <a href="#pills-pricetab" className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selectedType === 'invoice_date' ? 'active' : ''} order relative w-full`} id="pills-ordercategory" data-bs-toggle="pill" data-bs-target="#pills-pricetab" role="tab"   aria-controls="pills-pricetab" aria-selected="true">
                                        Invoice Date
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('ar_date')}>
                                    <a href="#pills-daterange" className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selectedType === 'ar_date' ? 'active' : ''} order relative w-full`} id="pills-daterangetab" data-bs-toggle="pill" data-bs-target="#pills-daterange" role="tab"
                                        aria-controls="pills-daterange" aria-selected="false">
                                        AR Date
                                    </a>
                                </li>
                                {/* <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('class')}>
                                    <a href="#pills-Class" className={`nav-link block text-base font-semibold text-[#AAA6AF] ${selectedType === 'class' ? 'active' : ''} order relative w-full`} id="pills-Classtab" data-bs-toggle="pill" data-bs-target="#pills-Class" role="tab"
                                        aria-controls="pills-Class" aria-selected="false">
                                        Class
                                    </a>
                                </li> */}
                            </ul>
                            <div className="tab-content w-[70%] h-[198px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane fade  ${selectedType === 'invoice_date' ? 'show active' : 'hidden'}  px-3`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-ordercategory">
                                    <div ref={dateRef} className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('invoice_start_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('invoice_start_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="From date"
                                                    value={selected.invoice_start_date === '' ? '' : moment(selected.invoice_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.invoice_start_date && (
                                                <Calendar
                                                    value={moment(selected.invoice_start_date).format('YYYY/MM/DD').invoice_start_date}
                                                    onChange={(val) => handleDateIN(val, 'invoice_start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('invoice_end_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('invoice_end_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="To date"
                                                    value={selected.invoice_end_date === '' ? '' : moment(selected.invoice_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.invoice_end_date && (
                                                <Calendar
                                                    value={(selected.invoice_end_date)}
                                                    onChange={(val) => handleDateIN(val, 'invoice_end_date')}
                                                    minDate={moment(selected.invoice_start_date).toDate()}
                                                    placeholder="Date from"
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${selectedType === 'ar_date' ? 'show active' : 'hidden'} px-3`} id="pills-daterange" role="tabpanel" aria-labelledby="pills-daterangetab">
                                    <div  ref={dateRef1} className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('ar_start_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('ar_start_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="From date"
                                                    value={selected.ar_start_date === '' ? '' : moment(selected.ar_start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.ar_start_date && (
                                                <Calendar
                                                    value={moment(selected.ar_start_date).format('YYYY/MM/DD').ar_start_date}
                                                    onChange={(val) => handleDateAR(val, 'ar_start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div 
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('ar_end_date')}
                                            >
                                                <label></label>
                                                <img 
                                                    src="/images/Iconawesome-calendar-alt.svg" 
                                                    alt="icon" 
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('ar_end_date')}
                                                />
                                                <input 
                                                    datepicker 
                                                    datepicker-autohide 
                                                    type="text" 
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]" 
                                                    placeholder="To date"
                                                    value={selected.ar_end_date === '' ? '' : moment(selected.ar_end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.ar_end_date && <Calendar 
                                                value={selected.ar_end_date} 
                                                onChange={(val) => handleDateAR(val, 'ar_end_date')} 
                                                minDate={moment(selected.ar_start_date).toDate()} 
                                                placeholder="Date to" />}
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane fade ${selectedType === 'class' ? 'show active' : 'hidden'} px-3 h-[198px] overflow-auto custom-scrollbar1`} id="pills-Class" role="tabpanel" aria-labelledby="pills-Classtab">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {outstandingInvoiceList.length > 0 && outstandingInvoiceList.map((ele, idx) => (
                                                <div key={idx} className="flex items-center mb-3">
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.class?.includes(ele?.CLASS) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.class?.includes(ele?.CLASS)}
                                                        onChange={() => HandleFilter('class', ele?.CLASS)}
                                                        borderColor={`${Filter.class?.includes(ele?.CLASS) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                    /> 
                                                    <label htmlFor="mn1" className="consumbales pl-3 sm:text-xs9 text-sm29 font-normal text-[#090406] text-left cursor-pointer">{ele?.CLASS}</label>
                                                </div>
                                            ))}
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>   
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-4">
                                <button type="button" 
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button 
                                    type="button" 
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]" 
                                    data-bs-dismiss="modal" 
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default OutstandingInvoiceReportFilterModal
